module.exports = __webpack_public_path__ + "img/list_white.2d679803.svg";